import { createFileRoute } from '@tanstack/react-router';

import { EngagementMetricsView } from 'src/sections/admin/white-glove/engagement-metrics-view';

/**
 * One engagement's metric catalog (WG-68).
 *
 * In the admin tree rather than on the work surface because a lead and a
 * platform admin need the same screen, and this is the only area both reach.
 * The view gates on lead-or-admin itself and reads through `/v1/staff/*`, which
 * authorises a lead on their own engagements.
 */
export const Route = createFileRoute('/admin-skidog/white-glove/$engagementId')({
  component: AdminEngagementMetricsPage,
});

function AdminEngagementMetricsPage() {
  const { engagementId } = Route.useParams();
  return <EngagementMetricsView engagementId={engagementId} />;
}
